<template>
  <ul
    v-if="!isDeleted"
    class="list-unstyled mb-0"
    :data-chat-id="source.chat_id"
    :data-message-id="source.id"
  >
    <li :class="classNameFirstOnToday">
      <div class="chat-day-title">
        <span
          class="title"
          style="color: #495057;"
        >Today</span>
      </div>
    </li>
    <li :class="{ right: isOutgoing }">
      <div class="conversation-list">
        <div class="chat-avatar">
          <img
            :src="require(isOutgoing ? '@/static/user__1_.png' : '@/static/user__2_.png')"
            width="32"
            height="32"
            class="rounded-circle"
          >
        </div>
        <div class="user-chat-content">
          <div class="ctext-wrap">
            <div
              class="ctext-wrap-content"
              :class="{
                'media-chat-item-search': isMessageIdSearch,
                'has-error': hasError,
              }"
            >
              <message-payload
                v-if="payload"
                style="white-space: pre-line;"
                :query="query"
                @email="onClickEmail"
              >
                {{ payload }}
              </message-payload>
              <attachment-box
                v-if="hasAttachment"
                :source="source"
              />
            </div>
            <div class="ctext-wrap-info">
              <div class="chat-time">
                <i class="ri-time-line align-middle mr-1" />
                <span class="align-middle">{{ createdAt }}</span>
              </div>

              <i
                class="ri-check-line ml-2"
                :class="{
                  'text-muted': isDelivered,
                  'text-info': isSeen,
                }"
              />

              <message-error
                :message="source"
                @error="onError"
              >
                <template slot-scope="{ hasError }">
                  <a
                    href="#"
                    class="chat-retry ml-4"
                    :data-error="hasError"
                    @click.prevent="onRetry"
                  >
                    <i class="ri-refresh-line align-middle mr-1" />
                    Retry
                  </a>
                </template>
              </message-error>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import dateTimeSameHuman from "../../../utils/dateTimeSameHuman";
import ServiceChat from "../../../services/chat";
import {
  EmitterClient,
  EmitterDelivery,
  MessageStatusDeleted,
  MessageStatusDelivered,
  MessageStatusSeen,
  TypeIncoming,
  TypeOutgoing,
} from "../../../services/chat/const";
import MessagePayload from "./Helpers/PayloadMessageRoomComponents";
import AttachmentBox from "./Helpers/AttachmentMessageRoomComponents";
import MessageError from "./Helpers/ErrorMessageRoomComponents";

/**
 * Message component
 */
export default {
  components: {
    MessagePayload,
    AttachmentBox,
    MessageError,
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    source: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hasError: false,
      toggler: false,
      classNameFirstOnToday: 'd-none',
    };
  },
  computed: {
    ...mapState('rooms', [
      'rooms',
    ]),
    ...mapState('room', [
      'messageIdSearch',
    ]),
    ...mapGetters('rooms', {
      searchModRoom: 'searchMod',
    }),
    ...mapGetters('roomSearch', {
      searchModRoomSearch: 'searchMod',
    }),
    type() {
      if (this.source.emitter === EmitterClient) {
        return TypeIncoming;
      } else {
        return TypeOutgoing;
      }
    },
    isIncoming() {
      return this.type === TypeIncoming;
    },
    isOutgoing() {
      return this.type === TypeOutgoing;
    },
    isEmitterDelivery() {
      return this.source.emitter === EmitterDelivery;
    },
    isDelivered() {
      return this.source.status === MessageStatusDelivered;
    },
    isSeen() {
      return this.source.status === MessageStatusSeen;
    },
    isDeleted() {
      return this.source.status === MessageStatusDeleted;
    },
    showAvatar() {
      return !this.isEmitterDelivery;
    },
    createdAt() {
      return dateTimeSameHuman.call(this, this.source.created_at);
    },
    isMessageIdSearch() {
      return this.source.id === this.messageIdSearch;
    },
    hasAttachment() {
      return Boolean(this.source.attachment);
    },
    query() {
      if (this.searchModRoom) {
        return this.$store.state.rooms.fetchFilter.query;
      }
      if (this.searchModRoomSearch) {
        return this.$store.state.roomSearch.query;
      }
      return '';
    },
    payload() {
      //const tmp = document.createElement("DIV");
      //tmp.innerHTML = this.source.payload;
//
      //let payload = tmp.textContent || tmp.innerText;
//
      //if (this.searchModRoom || this.searchModRoomSearch) {
      //  let q;
      //  if (this.searchModRoom) {
      //    q = this.$store.state.rooms.fetchFilter.query;
      //  } else if (this.searchModRoomSearch) {
      //    q = this.$store.state.roomSearch.query;
      //  }
      //  return payload.replaceAll(new RegExp(q, "ig"), '<strong>$&</strong>')
      //}

      return this.source.payload;
    },
  },
  created() {
    this.onRead();
  },
  mounted() {
    // причина ошибки не понятна, этот хак решает проблему
    setTimeout(() => {
      if (this.source._firstOnToday === true) {
        this.classNameFirstOnToday = '';
      }
    }, 100);
  },
  methods: {
    onClickEmail(email) {
      const room = JSON.parse(JSON.stringify(this.rooms[this.source.chat_id]));

      room.contact.email = email;

      this.$store.dispatch('addContact/setEmailAndEdit', room);
    },
    onRetry() {
      const {id, meta_id} = this.source;
      return meta_id ?
        ServiceChat.OnRetryByMetaId(meta_id) :
        ServiceChat.OnRetryById(id);
    },
    onRead() {
      if (this.isOutgoing) return;
      const {id, chat_id, status} = this.source;
      status !== MessageStatusSeen && ServiceChat.OnRead(chat_id, id);
    },
    onError(e) {
      this.hasError = e;
    },
  },
};
</script>

<style scoped>
.right .media-chat-item-search:not([class*=bg-]) {
  background-color: #EBEFFA !important;
  border-color: #EBEFFA !important;
}

.media-chat-item-search:not([class*=bg-]) {
  background-color: #22304E !important;
  border-color: #22304E !important;
}
</style>
